const base64String = (text) => window.btoa(unescape(encodeURIComponent(text)));

export default base64String;
